import RecentTransactions from '../../pages/Transactions/RecentTransactions';
import React, { useState } from 'react';
import { transactionStore } from '../../stores';
import { observer } from 'mobx-react';

const RecentTransactionsContainer = ({
	filteredTransactions,
	setFilteredTransactions,
	setViewMoreExpense,
	refresh,
	loading,
	setOpenTagModal,
	setViewMoreIncome,
}) => {
	const [incomeTable, setIncomeTable] = useState(true);
	const [expenseTable, setExpenseTable] = useState(false);

	const allIncomeTable = () => {
		setIncomeTable(true);
		setExpenseTable(false);
	};

	const allExpensesTable = () => {
		setExpenseTable(true);
		setIncomeTable(false);
	};

	return (
		<RecentTransactions
			incomeTable={incomeTable}
			expenseTable={expenseTable}
			refresh={refresh}
			loading={loading}
			transactions={transactionStore.transactions}
			allIncomeTable={allIncomeTable}
			allExpensesTable={allExpensesTable}
			filteredTransactions={filteredTransactions}
			setFilteredTransactions={setFilteredTransactions}
			setViewMoreExpense={setViewMoreExpense}
			setOpenTagModal={setOpenTagModal}
			setViewMoreIncome={setViewMoreIncome}
		/>
	);
};

export default observer(RecentTransactionsContainer);
